export default __webpack_public_path__ + "static/onze_aanpak_2-2325b4c385e3041004f7402e330896d6.jpg";